import React, { Component } from 'react';
import './AboutCard.css';

export default function AboutCard(props){
    return(
        <div className='about-card'>
            <h1>{props.heading}</h1>
            <p>
            {props.body}
            </p>
        </div>
    )
}